import { render, staticRenderFns } from "./ProfilePage.vue?vue&type=template&id=79019361&"
import script from "./ProfilePage.vue?vue&type=script&lang=ts&"
export * from "./ProfilePage.vue?vue&type=script&lang=ts&"
import style0 from "./ProfilePage.vue?vue&type=style&index=0&id=79019361&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports